import { Product } from "@omni/types/api/product/bff/product.model";
import { DeliveryTimeUnit } from "@omni/types/api/product/bff/shared/enums/deliveryTimeUnit.enum";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

import { DeliveryOption } from "@/components/Product/ECommerce/eCommerce.types";

const deliveryItemMapper = (
    type: string,
    product: Product<ProductFieldSet.Full>
): DeliveryOption => {
    const deliveryOption: Partial<DeliveryOption> = {
        deliveryType: type as DeliveryType
    };
    if (DeliveryType.HomeDelivery === type) {
        deliveryOption.deliveryTime = product.homeDeliveryTime;
        deliveryOption.deliveryTimeInHours = product.homeDeliveryTimeInHours;
        deliveryOption.deliveryTimeUnit =
            product.homeDeliveryTimeUnit as DeliveryTimeUnit;
        deliveryOption.deliveryCost = product.price?.deliveryCost || 0;
    } else if (DeliveryType.ClickAndCollect === type) {
        deliveryOption.deliveryTime =
            product.clickAndCollectDeliveryTimeInHours;
        deliveryOption.deliveryTimeInHours =
            product.clickAndCollectDeliveryTimeInHours;
        deliveryOption.deliveryTimeUnit = DeliveryTimeUnit.Hours;
        deliveryOption.deliveryCost = 0;
    }
    return deliveryOption as DeliveryOption;
};

export { deliveryItemMapper };
